// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-items[data-v-3f565297]{scroll-snap-type:x mandatory}.carousel-items>*[data-v-3f565297]{scroll-snap-align:start;-webkit-flex:none;flex:none}@media (min-width: 1024px){.carousel-items[data-v-3f565297]{scroll-snap-type:none}.carousel-items>*[data-v-3f565297]{scroll-snap-align:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
